import api from '../api/client';

export type SecurityLogSource = 'fail2ban' | 'ufw' | 'crowdsec' | 'lifeline';

export interface Fail2banJailStatus {
  name: string;
  currentlyFailed: number;
  totalBanned: number;
  banned: string[];
}

export interface SecuritySafeIp {
  id: number;
  ip_address: string;
  comment: string | null;
  created_by_email: string | null;
  created_at: string;
}

export interface CrowdSecEvent {
  id: string;
  createdAt: string;
  ip: string;
  scenario: string;
  action: string;
  duration: string;
  country: string;
  asName: string;
  httpPath: string;
  httpStatus: string;
  service: string;
  active: boolean;
}

export interface SecurityStatus {
  hostctl: boolean;
  hostctlError: string | null;
  fail2ban: { active: boolean; jails: Fail2banJailStatus[] };
  crowdsec: {
    installed: boolean;
    active: boolean;
    localBanCount: number;
    events: CrowdSecEvent[];
  };
  safeIps: SecuritySafeIp[];
}

export interface SecurityLogs {
  source: SecurityLogSource;
  available: boolean;
  lines: string[];
  hostctl: boolean;
}

export const securityService = {
  async getStatus(): Promise<SecurityStatus> {
    const res = await api.get('/api/sysadmin/security');
    return res.data.data;
  },
  async getLogs(source: SecurityLogSource, lines = 150): Promise<SecurityLogs> {
    const res = await api.get('/api/sysadmin/security/logs', { params: { source, lines } });
    return res.data.data;
  },
  async unban(ip: string): Promise<void> {
    await api.post('/api/sysadmin/security/unban', { ip });
  },
  async addSafeIp(ip: string, comment?: string): Promise<SecuritySafeIp> {
    const res = await api.post('/api/sysadmin/security/safe-ips', { ip, comment });
    return res.data.data;
  },
  async removeSafeIp(id: number): Promise<void> {
    await api.delete(`/api/sysadmin/security/safe-ips/${id}`);
  },
};
